import type { FC } from 'react'

import { Translation } from '@/app/translations/Translation'
import type { Product, CategoryData } from '@/modules/ecom-policy/types'

import Category from './Category'

type CategoriesMap = Record<number, Product & { counter: number }>

const Categories: FC<{
  selectedCategoryIds: number[] | null
  availableCategories: CategoryData[]
  onCategorySelect: (categoryId: number, currentIdList: number[] | null) => void
}> = ({ availableCategories, selectedCategoryIds, onCategorySelect }) => {
  const categoriesMap = availableCategories.reduce(
    (acc: CategoriesMap, { category, categoryId, isCategoryEmpty }) => {
      const cat = acc[categoryId] || { counter: 0, name: category }

      return {
        ...acc,
        [categoryId]: {
          ...cat,
          counter: isCategoryEmpty ? cat.counter : cat.counter + 1,
        },
      }
    },
    {}
  )

  const categoryList = categoriesMap
    ? Object.keys(categoriesMap).map(id => {
        const idInt = Number(id)

        return {
          id: idInt,
          name: categoriesMap[idInt].name,
          counter: categoriesMap[idInt].counter,
          isSelected: Boolean(selectedCategoryIds?.includes(idInt)),
        }
      })
    : []

  return (
    <div>
      <h3>
        <Translation id="Filter categories" />
      </h3>

      {categoryList.map(category => (
        <Category
          key={category.id}
          onCategorySelect={onCategorySelect}
          selectedCategoryIds={selectedCategoryIds}
          {...category}
        />
      ))}
    </div>
  )
}

export default Categories
